import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { createElement } from "@wordpress/element";
/**
 * External dependencies
 */

import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { RichText, getColorClassName, __experimentalGetGradientClass } from '@wordpress/block-editor';
export default function save(_ref) {
  var _classnames;

  var attributes = _ref.attributes;
  var backgroundColor = attributes.backgroundColor,
      borderRadius = attributes.borderRadius,
      customBackgroundColor = attributes.customBackgroundColor,
      customTextColor = attributes.customTextColor,
      customGradient = attributes.customGradient,
      linkTarget = attributes.linkTarget,
      gradient = attributes.gradient,
      rel = attributes.rel,
      text = attributes.text,
      textColor = attributes.textColor,
      title = attributes.title,
      url = attributes.url;
  var textClass = getColorClassName('color', textColor);
  var backgroundClass = !customGradient && getColorClassName('background-color', backgroundColor);

  var gradientClass = __experimentalGetGradientClass(gradient);

  var buttonClasses = classnames('wp-block-button__link', (_classnames = {
    'has-text-color': textColor || customTextColor
  }, _defineProperty(_classnames, textClass, textClass), _defineProperty(_classnames, 'has-background', backgroundColor || customBackgroundColor || customGradient || gradient), _defineProperty(_classnames, backgroundClass, backgroundClass), _defineProperty(_classnames, 'no-border-radius', borderRadius === 0), _defineProperty(_classnames, gradientClass, gradientClass), _classnames));
  var buttonStyle = {
    background: customGradient ? customGradient : undefined,
    backgroundColor: backgroundClass || customGradient || gradient ? undefined : customBackgroundColor,
    color: textClass ? undefined : customTextColor,
    borderRadius: borderRadius ? borderRadius + 'px' : undefined
  };
  return createElement("div", null, createElement(RichText.Content, {
    tagName: "a",
    className: buttonClasses,
    href: url,
    title: title,
    style: buttonStyle,
    value: text,
    target: linkTarget,
    rel: rel
  }));
}